// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__BDBZx","selected":"Chip_selected__hNwKS"};